<div class="wrapper">
  <bs-navbar></bs-navbar>
  <div class="content" #content>
    <router-outlet></router-outlet>
  </div>
  <bs-footer></bs-footer>
</div>
